import styled from 'styled-components';

export const StyledToolTipContent = styled.div`
  .tooltip-container {
    height: 100%;
  }

  font-family: var(--font-family), Arial;

  .heading {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    &--image-container {
      width: 24px;
      height: 24px;
      margin-right: 4px;

      &__img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &--text {
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      background: linear-gradient(
        180deg,
        #fffbff 0%,
        #cdb8f8 49.36%,
        #a58ae1 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      color: #ffff;
      @supports (
        background:
          linear-gradient(180deg, #fffbff 0%, #cdb8f8 49.36%, #a58ae1 100%) text
      ) {
        -webkit-text-fill-color: transparent;
      }
    }
  }

  .section {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }

    .divider {
      border-radius: 2px;
      background: linear-gradient(180deg, #2b1762 0%, #572ec7 100%);
      height: 2px;
      margin-bottom: 8px;
    }

    &--name {
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      background: linear-gradient(
        180deg,
        #fffbff 0%,
        #cdb8f8 49.36%,
        #a58ae1 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      color: #ffff;
      @supports (
        background:
          linear-gradient(180deg, #fffbff 0%, #cdb8f8 49.36%, #a58ae1 100%) text
      ) {
        -webkit-text-fill-color: transparent;
      }
      margin-bottom: 8px;
    }

    &--list {
      padding: 0;
      margin: 0;

      &__item {
        list-style: none;
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        &:last-child {
          margin-bottom: 0;
        }

        .item {
          &--image-container {
            width: 24px;
            height: 24px;
            margin-right: 8px;

            &__img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          &--text {
            color: #fff;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }
        }
      }
    }
  }
`;
